import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { ChapterGroup } from '../models/chapter-group';
import { updateChapterGroupEndpoint } from './const';

export const updateChapterGroup = (chapterGroup: ChapterGroup) => {
    return getHttpClient().post({ url: updateChapterGroupEndpoint, data: JSON.stringify(chapterGroup) });
};
